// Backend configuration
const API_CONTEXT_PATH = '/api/v1.0';

function normalizeBaseUrl(value) {
	if (!value) {
		return `http://localhost:8084${API_CONTEXT_PATH}`;
	}

	return value.endsWith(API_CONTEXT_PATH) ? value : `${value.replace(/\/$/, '')}${API_CONTEXT_PATH}`;
}

export const API_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL);
export const AUTH_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_AUTH_API_BASE_URL || process.env.REACT_APP_API_BASE_URL);

export default API_BASE_URL;
